import React from 'react';
import { NavLink } from 'react-router-dom'
import Services from '../../api/Services';


const ServiceSidebar = ({ setLoading }) => {



    return (
        <div className="service-sidebar">
            <div className="service-catagory">
                <ul>
                    {Services.slice(0, 9).map((serves, index) => (
                        <li key={index}>
                            <NavLink
                                to={`/services/${serves.slug}`}
                                onClick={() => setLoading(false)}
                                className={({ isActive }) => (isActive ? "active" : "")}
                            >
                                {serves.title} <i className="flaticon-right-arrow-1"></i>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="service-info">
                <div className="icon">
                    <i className="flaticon-phone-call"></i>
                </div>
                <h2>Looking for
                    logistics service
                    Provider?</h2>
                <span>Call anytime</span>
                <div className="num">
                    <span>1300 100 868</span>
                </div>
            </div>
        </div>
    )
}

export default ServiceSidebar;

